'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
var _faTimesCircle = require('@fortawesome/fontawesome-free-regular/faTimesCircle');
var _faTimesCircle2 = _interopRequireDefault(_faTimesCircle);
var _ProductCard = require('../productCard/ProductCard');
var _ProductCard2 = _interopRequireDefault(_ProductCard);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // eslint-disable-line
// eslint-disable-line

var ProductSlide = function (_React$Component) {
  _inherits(ProductSlide, _React$Component);
  function ProductSlide() {
    _classCallCheck(this, ProductSlide);
    var _this = _possibleConstructorReturn(this, (ProductSlide.__proto__ || Object.getPrototypeOf(ProductSlide)).call(this));
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  _createClass(ProductSlide, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      this.props.onToggleClick(this.slide);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      return _react2.default.createElement('div', {
        className: 'product-slide ' + this.props.className + ' ' + (this.props.active ? 'is-active' : ''),
        id: this.props.product.slug,
        ref: function ref(slide) {
          _this2.slide = slide;
        }
      }, _react2.default.createElement('a', {
        href: '/products/' + this.props.product.slug,
        className: 'product-slide__link',
        onClick: this.handleClick
      }, _react2.default.createElement('img', {
        className: 'product-slide__image product-slide__image--' + this.props.product.image.type,
        src: this.props.product.image.src,
        alt: this.props.product.image.alt
      })), _react2.default.createElement(_ProductCard2.default, {
        active: this.props.active,
        bazaarVoiceEnabled: this.props.bazaarVoiceEnabled,
        className: 'product-slide__card',
        onCloseClick: this.props.onToggleClick,
        nutritionFacts: this.props.nutritionFacts,
        product: this.props.product,
        social: this.props.social,
        socialEnabled: this.props.socialEnabled
      }));
    }
  }]);
  return ProductSlide;
}(_react2.default.Component);
ProductSlide.defaultProps = {
  active: false,
  bazaarVoiceEnabled: true,
  className: '',
  nutritionFacts: {},
  onToggleClick: function onToggleClick() {
    return false;
  },
  social: {},
  socialEnabled: true
};
ProductSlide.propTypes = {
  active: _propTypes2.default.bool,
  bazaarVoiceEnabled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  onToggleClick: _propTypes2.default.func,
  nutritionFacts: _propTypes2.default.shape({
    calorieSource: _propTypes2.default.string,
    dailyValue: _propTypes2.default.string,
    disclaimer: _propTypes2.default.string,
    factPunctuation: _propTypes2.default.string,
    ingredientsTitle: _propTypes2.default.string,
    perServing: _propTypes2.default.string,
    servingSize: _propTypes2.default.string,
    threeColumn: _propTypes2.default.bool
  }),
  product: _propTypes2.default.shape({
    brand_code: _propTypes2.default.string,
    description: _propTypes2.default.string,
    image: _propTypes2.default.shape({
      src: _propTypes2.default.string,
      alt: _propTypes2.default.string,
      type: _propTypes2.default.string
    }),
    ingredient: _propTypes2.default.array,
    name: _propTypes2.default.string,
    nutrition: _propTypes2.default.shape({}),
    product_info: _propTypes2.default.shape({
      serving_size: _propTypes2.default.string,
      serving_units_code: _propTypes2.default.string
    }),
    slug: _propTypes2.default.string,
    social: _propTypes2.default.shape({
      email: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        subject: _propTypes2.default.string,
        message: _propTypes2.default.string
      }),
      facebook: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string,
        subject: _propTypes2.default.string,
        image: _propTypes2.default.string
      }),
      pinterest: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string,
        image: _propTypes2.default.string
      }),
      twitter: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string
      })
    })
  }).isRequired,
  social: _propTypes2.default.shape({
    emailSubject: _propTypes2.default.string,
    emailMessage: _propTypes2.default.string,
    emailUrl: _propTypes2.default.string,
    facebookAppId: _propTypes2.default.string,
    facebookIcon: _propTypes2.default.oneOf(['default', 'square']),
    facebookImage: _propTypes2.default.string,
    facebookMessage: _propTypes2.default.string,
    facebookSubject: _propTypes2.default.string,
    facebookUrl: _propTypes2.default.string,
    pinterestIcon: _propTypes2.default.oneOf(['default', 'p', 'square']),
    pinterestImage: _propTypes2.default.string,
    pinterestMessage: _propTypes2.default.string,
    pinterestUrl: _propTypes2.default.string,
    twitterIcon: _propTypes2.default.oneOf(['default', 'square']),
    twitterMessage: _propTypes2.default.string,
    twitterUrl: _propTypes2.default.string,
    services: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['email', 'facebook', 'pinterest', 'print', 'twitter']))
  }),
  socialEnabled: _propTypes2.default.bool
};
exports.default = ProductSlide;